// NO EDITAR A MANO
import {ITraduccionMapKeys} from "services-comun/modules/traduccion/map";

import {checkClean} from "../langs";

export type CalendarioHaceXHorasParam = "horas";
export type CalendarioHaceXMinutosParam = "minutos";

export type CalendarioHaceXHorasParams = Record<CalendarioHaceXHorasParam, string|number>;
export type CalendarioHaceXMinutosParams = Record<CalendarioHaceXMinutosParam, string|number>;

export interface CalendarioMesesCortoRecord extends ITraduccionMapKeys {
    "1"?: string;
    "2"?: string;
    "3"?: string;
    "4"?: string;
    "5"?: string;
    "6"?: string;
    "7"?: string;
    "8"?: string;
    "9"?: string;
    "10"?: string;
    "11"?: string;
    "12"?: string;
}
export type CalendarioMesesCortoKeys = keyof CalendarioMesesCortoRecord;

export interface Calendario {
    ayer: string;
    hace_1_hora: string;
    hace_x_horas: (params?: Partial<CalendarioHaceXHorasParams>)=>string;
    hace_x_minutos: (params?: Partial<CalendarioHaceXMinutosParams>)=>string;
    hoy: string;
    meses_corto: (key: CalendarioMesesCortoKeys)=>string;
}

const MAPPING: Record<string, string> = {
    "de-AT": "de",
    "de-DE": "de",
    "en-CA": "en",
    "en-US": "en",
    "es-AR": "es",
    "es-BO": "es",
    "es-CL": "es",
    "es-CR": "es",
    "es-DO": "es",
    "es-EC": "es",
    "es-ES": "es",
    "es-HN": "es",
    "es-MX": "es",
    "es-PA": "es",
    "es-PE": "es",
    "es-PY": "es",
    "es-UY": "es",
    "es-VE": "es",
    "fr-FR": "en",
    "it-IT": "it",
    "nl-NL": "nl",
    "pt-BR": "pt",
    "pt-PT": "pt",
    "ru-RU": "ru"
};

export default (lang: string, defecto?: string): Promise<Calendario> => import(/* webpackChunkName: "i18n/[request]/calendario" */ `i18n/.src/${checkClean(lang, defecto, MAPPING)}/calendario`).then(module=> module.default);
